import type { ICustomer } from '@becksdevteam/becks-invoicing';
import { createAction, props } from '@ngrx/store';

export const loadDealers = createAction('[Shared: Sales Lookup] Load Dealers');
export const loadDealersSuccess = createAction(
  '[Shared: Sales Lookup] Load Dealers Success',
  props<{ dealers: ICustomer[] }>()
);
export const loadDealersFailure = createAction(
  '[Shared: Sales Lookup] Load Dealers Failure',
  props<{ error: unknown }>()
);
